import { Show } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";
import BasicInfoSection from "./BasicInfoSection";
import SpecializationFeesSection from "./SpecializationFeesSection";

const ShowSpecializations = () => {
  return (
    <Show
      title="Детайли на специалност"
      actions={<BackButtonToolbar />}
    >
      <SectionTitle
        paddingY={2}
        title="Основна информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <BasicInfoSection />

      <SectionTitle
        paddingY={2}
        title="Такси специалности"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SpecializationFeesSection />
    </Show>
  );
};

export default ShowSpecializations;
